export default "__VITE_ASSET__CbKZn28Q__"